var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3936EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 12.8572H5.99916C5.75631 12.8572 5.55274 12.775 5.38845 12.6107C5.22416 12.4464 5.14202 12.2429 5.14202 12C5.14202 11.7572 5.22416 11.5536 5.38845 11.3893C5.55274 11.225 5.75631 11.1429 5.99916 11.1429H15.5563L13.1134 8.70002C12.942 8.52859 12.8599 8.32859 12.867 8.10002C12.8742 7.87145 12.9563 7.67145 13.1134 7.50002C13.2849 7.32859 13.4884 7.23931 13.7242 7.23216C13.9599 7.22502 14.1634 7.30716 14.3349 7.47859L18.2563 11.4C18.342 11.4857 18.4027 11.5786 18.4384 11.6786C18.4742 11.7786 18.492 11.8857 18.492 12C18.492 12.1143 18.4742 12.2214 18.4384 12.3214C18.4027 12.4214 18.342 12.5143 18.2563 12.6L14.3349 16.5214C14.1634 16.6929 13.9599 16.775 13.7242 16.7679C13.4884 16.7607 13.2849 16.6714 13.1134 16.5C12.9563 16.3286 12.8742 16.1286 12.867 15.9C12.8599 15.6714 12.942 15.4714 13.1134 15.3L15.5563 12.8572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8e6584849c9bf8b62ccb303cf6f634e8.svg";
export { ForwardRef as ReactComponent };